// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__2kQ0d","heading":"style__heading__M8Mmk","welcomeBox":"style__welcomeBox__DDhEc"};